import React, { useState } from 'react'
import { Input } from '@material-tailwind/react'
import { getValidationErrors } from './common'
import './CustomInput.css'

interface CustomInputProps {
    label: any
    field: string
    success?: boolean
    type?: string
    value?: any
    register?: any
    maxLength?: string
    minLength?: string
    disabled?: boolean
    errors?: any
    className?: string
    visible?: boolean
    rules?: any
    icon?: any
    capitalize?: "uppercase" | "lowercase" | "capitalize" | "none"
    onChange?: (e: any) => void
    onBlur?: (e: any) => void
    onKeyDown?: (e: any) => void
}

function CustomInput({
    label,
    field,
    success = false,
    type = "text",
    value,
    register,
    maxLength = "",
    minLength = "",
    disabled = false,
    errors = null,
    className = "",
    visible = true,
    icon = null,
    rules = {},
    capitalize = "none",
    onChange = () => { },
    onBlur = () => { },
    onKeyDown = () => { },
}: CustomInputProps) {

    const validationError = errors && getValidationErrors(errors, field, label, rules);
    const [valueInput, setValueInput] = useState(value);

    function getRules() {
        if (!visible && rules) {
            rules['required'] = false
        }
        return rules
    }

    function getSimpleInput() {
        return (
            <div className={className || 'w-72'}>
                <Input size="lg" label={label} icon={icon} success={success} type={type} value={valueInput} disabled={disabled} crossOrigin="anonymous" onChange={(e: any) => handleOnChange?.(e)} onBlur={(e: any) => onBlur?.(e)} onKeyDown={onKeyDown}/>
            </div>
        )
    }

    const handleOnChange = (e: any) => {
        let value: string = e.target.value;
        onChange(value);
        setValueInput(value);
    }

    const handleOnBlur = (e: any) => {
        let value: string = e.target.value;
        if (capitalize === "uppercase") {
            value = value.toUpperCase();
        } else if (capitalize === "lowercase") {
            value = value.toLowerCase();
        } else if (capitalize === "capitalize") {
            value = value.replace(/\b\w/g, (c) => c.toUpperCase());
        }
        onBlur(value);
        setValueInput(value);
    }

    if (!register) {
        return getSimpleInput()
    }

    return (
        visible ? (
            <div className={className || ''}>
                <Input style={{ textTransform: capitalize }} color={validationError ? ("red"):(null)} size="lg" label={label} icon={icon} success={success} type={type} value={valueInput} maxLength={maxLength} minLength={minLength} disabled={disabled} error={validationError} errors={errors} className={className} crossOrigin="anonymous"  {...register(field, { ...getRules(), onChange: (e: any) => handleOnChange?.(e), onBlur: (e: any) => handleOnBlur(e) })} onKeyDown={onKeyDown}/>
                <label className='label-input-error'> {validationError ? (validationError):("")}</label>
            </div>
        ) : null
    )
}
export default CustomInput